import * as React from "react"
import { Container, ListLayout, Icon } from "@/components"
import * as styles from "./index.module.scss"

interface IProps {
  content: PartnerRights
}

const PartnerRights: React.FC<IProps> = ({ content }) => {
  console.debug('PartnerRights.props.content', content)
  return (
    <div className={styles.partnerRightsContent}>
      <Container className={styles.partnerRights} isSmall={true}>
        <h2>{content.title}</h2>
        <ListLayout listData={content.data}>
          {(item: PartnerRightsList) => (
            <div className={styles.inner}>
              <Icon name={item.icon} />
              <h4>{item.name}</h4>
              <p>{item.describe}</p>
            </div>
          )}
        </ListLayout>
      </Container>
    </div>
  )
}

export default PartnerRights
